const MS_MINUTE = 60_000;
const MS_HOUR = 3_600_000;
const MS_DAY = 86_400_000;

function timeString(date: Date): string {
  return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

function shortWeekday(date: Date): string {
  return date.toLocaleDateString(undefined, { weekday: 'long' });
}

function shortDate(date: Date): string {
  return date.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Formats a schedule start date into a human-friendly relative string.
 *
 * - Within the next hour: "In 45 minutes"
 * - Today: "Today at 2:00 PM"
 * - Tomorrow: "Tomorrow at 2:00 PM"
 * - Within 6 days: "Wednesday at 2:00 PM"
 * - Beyond: "Wed, May 14 at 2:00 PM"
 */
export function formatScheduleDate(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  const diffMs = date.getTime() - now.getTime();

  if (diffMs < 0) {
    return `${shortDate(date)} at ${timeString(date)}`;
  }

  if (diffMs < MS_HOUR) {
    const mins = Math.max(1, Math.round(diffMs / MS_MINUTE));
    return mins === 1 ? 'In 1 minute' : `In ${mins} minutes`;
  }

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfTarget = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dayDiff = Math.round((startOfTarget.getTime() - startOfToday.getTime()) / MS_DAY);

  if (dayDiff === 0) {
    return `Today at ${timeString(date)}`;
  }
  if (dayDiff === 1) {
    return `Tomorrow at ${timeString(date)}`;
  }
  if (dayDiff <= 6) {
    return `${shortWeekday(date)} at ${timeString(date)}`;
  }

  return `${shortDate(date)} at ${timeString(date)}`;
}
